import * as actionTypes from './actionTypes';
import * as actions from './index';

 
export const crmSearchUsers = (obj = {}) => {
    return dispatch => {
        dispatch({ type: actionTypes.CRM_SEARCH_USERS_START });
        console.log(obj);
        window.flow.crmSearchUsers(obj).then(res => {
            dispatch({ type: actionTypes.CRM_SEARCH_USERS_SUCCESS, persons: res.data});
        }).catch(res => {
						dispatch({ type: actionTypes.CRM_SEARCH_USERS_FAIL});
            dispatch(actions.applicationError(res.message));
        });
    };
};
export const crmSearchUsersCsv = (obj = {}) => {
    return dispatch => {
        window.flow.crmSearchUsersCsv(obj).then(res => {
            dispatch({ type: actionTypes.CRMUSERS_CSV_DOWNLOAD_SUCCESS, csvpersons: res.csvdata});
        }).catch(res => {
            dispatch(actions.applicationError(res.message));
        });
    };
};
export const crmGetUserById = (obj = {}) => {
	return dispatch => {
		dispatch({ type: actionTypes.CRM_GET_USER_START });
		console.log(obj);
		window.flow.crmSearchUsers(obj).then(res => {
			console.log(res);
			dispatch({ type: actionTypes.CRM_GET_USER_SUCCESS, person: res.data[0]});
		}).catch(res => {
			dispatch({ type: actionTypes.CRM_GET_USER_FAIL});
			dispatch(actions.applicationError(res.message));
		});
	};
};

export const crmCreateUser = (obj) => {
    return dispatch => {
        dispatch({ type: actionTypes.CRM_CREATE_USER_START});
        window.flow.crmCreateUser(obj).then(res => {
						console.log(res);
            dispatch({ type: actionTypes.CRM_CREATE_USER_SUCCESS, newpersonid: res.data.insertId});
            dispatch(actions.crmSearchUsers());
        }).catch(res => {
						dispatch({ type: actionTypes.CRM_CREATE_USER_FAIL});
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const crmEditUser = (obj) => {
    return dispatch => {
        dispatch({ type: actionTypes.CRM_EDIT_USER_START});
        window.flow.crmEditUser(obj).then(res => {
						console.log(res);
            dispatch({ type: actionTypes.CRM_EDIT_USER_SUCCESS});
            dispatch(actions.crmSearchUsers());
        }).catch(res => {
						dispatch({ type: actionTypes.CRM_EDIT_USER_FAIL});
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const crmDeleteUser = (id) => {
    return dispatch => {
        dispatch({ type: actionTypes.CRM_DELETE_USER_START});
        window.flow.crmDeleteUser({ id: id }).then(res => {
						console.log(res);
            dispatch({ type: actionTypes.CRM_DELETE_USER_SUCCESS});
            dispatch(actions.crmSearchUsers());
        }).catch(res => {
						dispatch({ type: actionTypes.CRM_DELETE_USER_FAIL});
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const crmSearchGroup = (obj = {}) => {
	return dispatch => {
		dispatch({ type: actionTypes.CRM_SEARCH_GROUP_START });
		console.log(obj);
		window.flow.crmGetGroups(obj).then(res => {
			console.log(res);
			dispatch({ type: actionTypes.CRM_SEARCH_GROUP_SUCCESS, groups: res.data});
		}).catch(res => {
			dispatch({ type: actionTypes.CRM_SEARCH_GROUP_FAIL});
			dispatch(actions.applicationError(res.message));
		});
	};
};

export const crmGetGroupCsv = (obj = {}) => {
    return dispatch => {
        dispatch({ type: actionTypes.CRM_GET_GROUP_CSV_START });
				console.log(obj);
        window.flow.crmGetGroupCsv(obj).then(res => {
					console.log(res);
					dispatch({ type: actionTypes.CRM_GET_GROUP_CSV_SUCCESS, group: res.data});
        }).catch(res => {
					dispatch({ type: actionTypes.CRM_GET_GROUP_CSV_FAIL});
          dispatch(actions.applicationError(res.message));
        });
    };
};

export const crmGetGroup = (obj = {}) => {
    return dispatch => {
        dispatch({ type: actionTypes.CRM_GET_GROUP_START });
				console.log(obj);
        window.flow.crmGetGroup(obj).then(res => {
					console.log(res);
					dispatch({ type: actionTypes.CRM_GET_GROUP_SUCCESS, group: res.data});
        }).catch(res => {
					dispatch({ type: actionTypes.CRM_GET_GROUP_FAIL});
          dispatch(actions.applicationError(res.message));
        });
    };
};

export const crmCreateGroup = (obj = {}) => {
    return dispatch => {
        dispatch({ type: actionTypes.CRM_CREATE_GROUP_START });
				console.log(obj);
        window.flow.crmCreateGroup(obj).then(res => {
					console.log(res);
					dispatch({ type: actionTypes.CRM_CREATE_GROUP_SUCCESS, groups: res.data});
        }).catch(res => {
					dispatch({ type: actionTypes.CRM_CREATE_GROUP_FAIL});
          dispatch(actions.applicationError(res.message));
        });
    };
};

export const crmSaveGroup = (obj = {}) => {
    return dispatch => {
        dispatch({ type: actionTypes.CRM_SAVE_GROUP_START });
				console.log(obj);
        window.flow.crmEditGroup(obj).then(res => {
					console.log(res);
					// let ogroup = res[0];
					// for(var g of res.data) 
						// if(g.id == obj.gid)
							// ogroup = g;
					dispatch({ type: actionTypes.CRM_SAVE_GROUP_SUCCESS, groups: res.data.groups, group: res.data.group});
        }).catch(res => {
					dispatch({ type: actionTypes.CRM_SAVE_GROUP_FAIL});
          dispatch(actions.applicationError(res.message));
        });
    };
};

export const crmDeleteGroup = (obj = {}) => {
    return dispatch => {
        dispatch({ type: actionTypes.CRM_DELETE_GROUP_START });
				console.log(obj);
        window.flow.crmDeleteGroup(obj).then(res => {
					console.log(res);
					dispatch({ type: actionTypes.CRM_DELETE_GROUP_SUCCESS, groups: res.data});
        }).catch(res => {
					dispatch({ type: actionTypes.CRM_DELETE_GROUP_FAIL});
          dispatch(actions.applicationError(res.message));
        });
    };
};

export const crmAddtoGroup = (obj = {}) => {
    return dispatch => {
        dispatch({ type: actionTypes.CRM_ADDTO_GROUP_START });
				console.log(obj);
        window.flow.crmAddGroupUser(obj).then(res => {
					console.log(res);
					dispatch({ type: actionTypes.CRM_ADDTO_GROUP_SUCCESS, group: res.data});
        }).catch(res => {
					dispatch({ type: actionTypes.CRM_ADDTO_GROUP_FAIL});
          dispatch(actions.applicationError(res.message));
        });
    };
};

export const crmRemovefromGroup = (obj = {}) => {
    return dispatch => {
        dispatch({ type: actionTypes.CRM_REMOVEFROM_GROUP_START });
				console.log(obj);
        window.flow.crmRemGroupUser(obj).then(res => {
					console.log(res);
					dispatch({ type: actionTypes.CRM_REMOVEFROM_GROUP_SUCCESS, group: res.data});
        }).catch(res => {
					dispatch({ type: actionTypes.CRM_ADDTO_GROUP_FAIL});
          dispatch(actions.applicationError(res.message));
        });
    };
};



export const crmSearchInst = (obj = {}) => {
    return dispatch => {
        dispatch({ type: actionTypes.CRM_SEARCH_INST_START });
				console.log(obj);
        //dispatch({ type: actionTypes.CRM_SEARCH_INST_SUCCESS });
        window.flow.crmSearchInst(obj).then(res => {
					console.log(res);
					dispatch({ type: actionTypes.CRM_SEARCH_INST_SUCCESS, insts: res.data});
        }).catch(res => {
					dispatch({ type: actionTypes.CRM_SEARCH_INST_FAIL});
          dispatch(actions.applicationError(res.message));
        });
    };
};

export const crmGetAllInst = (obj = {}) => {
    return dispatch => {
        dispatch({ type: actionTypes.CRM_SEARCH_INST_START });
				// console.log(obj);
        //dispatch({ type: actionTypes.CRM_SEARCH_INST_SUCCESS });
        window.flow.crmSearchInst({'limit':9999}).then(res => {
					// console.log(res);
					dispatch({ type: actionTypes.CRM_ALL_INST_SUCCESS, allinsts: res.data});
        }).catch(res => {
					dispatch({ type: actionTypes.CRM_SEARCH_INST_FAIL});
          dispatch(actions.applicationError(res.message));
        });
    };
};

export const crmCreateInst = (obj) => {
    return dispatch => {
        dispatch({ type: actionTypes.CRM_CREATE_INST_START});
        window.flow.crmCreateInst(obj).then(res => {
						console.log(res);
            dispatch({ type: actionTypes.CRM_CREATE_INST_SUCCESS, newinstid: res.data.insertId});
            dispatch(actions.crmSearchInst());
        }).catch(res => {
			dispatch({ type: actionTypes.CRM_CREATE_INST_FAIL});
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const crmEditInst = (obj) => {
    return dispatch => {
        dispatch({ type: actionTypes.CRM_EDIT_INST_START});
        window.flow.crmEditInst(obj).then(res => {
			console.log(res);
            dispatch({ type: actionTypes.CRM_EDIT_INST_SUCCESS});
            dispatch(actions.crmSearchInst());
        }).catch(res => {
			dispatch({ type: actionTypes.CRM_EDIT_INST_FAIL});
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const crmDeleteInst = (id) => {
    return dispatch => {
        dispatch({ type: actionTypes.CRM_DELETE_INST_START});
        window.flow.crmDeleteInst({ id: id }).then(res => {
			console.log(res);
            dispatch({ type: actionTypes.CRM_DELETE_INST_SUCCESS});
            dispatch(actions.crmSearchInst());
        }).catch(res => {
			dispatch({ type: actionTypes.CRM_DELETE_INST_FAIL});
            dispatch(actions.applicationError(res.message));
        });
    };
};
